/* eslint-disable linebreak-style */
import { withPortalProviders, withPortalThemeLegacy } from 'modules/utils';
import {
  Facts, Numbers, Campos, About, Streaming, Gallery, SubWebSchedule, Files,
  SubWebDepartment, SubWebCourses, SubWebContacts, OneFact,
  Tables, Header, Testimonials as TestimonialsWithLink, FAQ
} from '@uaveiro/ui';
import SubWebWarnings from './SubWebWarnings/SubWebWarnings';
import SubWebEvents from './SubWebEvents/SubWebEvents';

import ArticleThumbnail from '../assets/imgs/modules/article.png';
import CampusThumbnail from '../assets/imgs/modules/campus.png';
import NewsThumbnail from '../assets/imgs/modules/news.png';
import FactsThumbnail from '../assets/imgs/modules/facts.png';
import TestimonialsThumbnail from '../assets/imgs/modules/testimonials.png';
import SliderThumbnail from '../assets/imgs/modules/slider.png';
import NumbersThumbnail from '../assets/imgs/modules/numbers.png';
import AgendaThumbnail from '../assets/imgs/modules/agenda.png';
import SubWebDepartmentThumbnail from '../assets/imgs/modules/department.png';
import CardsThumbnail from '../assets/imgs/modules/cards.png';
import ContestsThumbnail from '../assets/imgs/modules/contests.png';
import TimelyThumbnail from '../assets/imgs/modules/timely.png';
import ImageThumbnail from '../assets/imgs/modules/panoramic.png';
import MultiColumnsThumbnail from '../assets/imgs/modules/multicolumns.png';
import SubWebLinksThumbnail from '../assets/imgs/modules/links.png';
import SubWebCoursesThumbnail from '../assets/imgs/modules/linkscourses.png';
import SubWebPeopleThumbnail from '../assets/imgs/modules/SubWebPeople.png';
import SubWebContactsThumbnail from '../assets/imgs/modules/subWebContacts.png';
import OneFactThumbnail from '../assets/imgs/modules/onefact.png';
import TablesThumbnail from '../assets/imgs/modules/tables.png';
import SubWebVideoThumbnail from '../assets/imgs/modules/SubWebVideo.png';
import GalleryThumbnail from '../assets/imgs/modules/Gallery.png';
import SubWebScheduleThumbnail from '../assets/imgs/modules/SubWebSchedule.png';
import SubWebWarningsThumbnail from '../assets/imgs/modules/SubWebWarnings.png';
// import SubWebFilesThumbnail from '../assets/imgs/modules/SubWebFiles.png';
import SubWebEventsThumbnail from '../assets/imgs/modules/SubWebEvents.png';
import TestimonialsWithLinkThumbnail from '../assets/imgs/modules/testimonials-with-link.png';
import XperimentaThumbnail from '../assets/imgs/modules/xperimenta.png';
import FAQThumbnail from '../assets/imgs/modules/FAQ.png';

import Placeholder from './Placeholder/Placeholder';
import PlaceholderEditor from './Placeholder/PlaceholderEditor';
import SliderEditor from './Slider/SliderEditor';
import News from './News/News';
import NewsEditor from './News/NewsEditor';
import Contests from './Contests/Contests';
import ContestsEditor from './Contests/ContestsEditor';
import Timely from './Timely/Timely';
import TimelyEditor from './Timely/TimelyEditor';
import ArticleEditor from './Article/ArticleEditor';
import Article from './Article/Article';
import SideNavJSON from './SideNav/SideNavJSON';
import SeoEditor from './Seo/SeoEditor';
import FactsEditor from './Facts/FactsEditor';
import NumbersEditor from './Numbers/NumbersEditor';
import Agenda from './Agenda/Agenda';
import AgendaEditor from './Agenda/AgendaEditor';
import ImageEditor from './Image/ImageEditor';
import MultiColumnsEditor from './MultiColumns/MultiColumnsEditor'
import CardsEditor from './Cards/CardsEditor';
import Cards from './Cards/Cards';
import SubwebDepartmentEditor from './SubWebDepartment/SubWebDepartmentEditor';
import SubWebLinksEditor from './SubWebLinks/SubWebLinksEditor';
import SubWebCoursesInternal from './SubWebCourses/SubWebCourses';
import SubWebCoursesEditor from './SubWebCourses/SubWebCoursesEditor';
import TestimonialsEditor from './Testimonials/TestimonialsEditor';
import TestimonialsWithLinkEditor from './TestimonialsWithLink/TestimonialsWithLinkEditor';
import SubWebPeople from './SubWebPeople/SubWebPeople';
import SubWebPeopleEditor from './SubWebPeople/SubWebPeopleEditor';
import SubWebContactsEditor from './SubWebContacts/SubWebContactsEditor';
import OneFactEditor from './OneFact/OneFactEditor';
import CampusEditor from './Campus/CampusEditor';
import TablesEditor from './Tables/TablesEditor';
import SubWebVideoEditor from './SubWebVideo/SubWebVideoEditor';
import GalleryEditor from './Gallery/GalleryEditor';
import FaqEditor from './FAQ/FaqEditor';
// import SubWebFilesEditor from './SubWebFiles/SubWebFilesEditor';
import SubWebEventsEditor from './SubWebEvents/SubWebEventsEditor';
import SubWebWarningsEditor from './SubWebWarnings/SubWebWarningsEditor';
import SubWebScheduleEditor from './SubWebSchedule/SubWebScheduleEditor';
import XperimentaEditor from './Xperimenta/XperimentaEditor';
import Xperimenta from './Xperimenta/Xperimenta';
import MultiColumns from './MultiColumns/MultiColumns';

import { getDefault as getDefaultArticle } from './Article/utils'
import { getDefault as getDefaultSlider } from './Slider/utils'
import { getDefault as getDefaultNews } from './News/utils'
import { getDefault as getDefaultContests } from './Contests/utils'
import { getDefault as getDefaultTimely } from './Timely/utils'
import { getDefault as getDefaultTestimonials } from './Testimonials/utils'
import { getDefault as getDefaultTestimonialsWithLink } from './TestimonialsWithLink/utils'
import { getDefault as getDefaultCampus } from './Campus/utils'
import { getDefault as getDefaultFacts } from './Facts/utils'
import { getDefault as getDefaultNumbers } from './Numbers/utils'
import { getDefault as getDefaultAgenda } from './Agenda/utils'
import { getDefault as getDefaultCards } from './Cards/utils'
import { getDefault as getDefaultSubWebDepartment } from './SubWebDepartment/utils'
import { getDefault as getDefaultImage, generateModule as generateImage } from './Image/utils'
import { getDefault as getDefaultMultiColumns } from './MultiColumns/utils'
import { getDefault as getDefaultSubWebLinks } from './SubWebLinks/utils'
import { getDefault as getDefaultSubWebCourses } from './SubWebCourses/utils'
import { getDefault as getDefaultSubWebPeople } from './SubWebPeople/utils'
import { getDefault as getDefaultSubWebContacts } from './SubWebContacts/utils'
import { getDefault as getDefaultOneFact } from './OneFact/utils'
import { getDefault as getDefaultTables } from './Tables/utils'
import { getDefault as getDefaultSubWebVideo } from './SubWebVideo/utils'
import { getDefault as getDefaultGallery } from './Gallery/utils'
// import { getDefault as getDefaultSubWebFiles } from './SubWebFiles/utils'
import { getDefault as getDefaultSubWebEvents } from './SubWebEvents/utils'
import { getDefault as getDefaultSubWebSchedule } from './SubWebSchedule/utils'
import { getDefault as getDefaultSubWebWarnings } from './SubWebWarnings/utils'
import { getDefault as getDefaultXperimenta } from './Xperimenta/utils'
import { getDefault as getDefaultFAQ } from './FAQ/utils'

export const hidden = ['SEO', 'Breadcrumbs', 'SideNav'];

export const moduleDefaults = {
  module: Placeholder,
  editor: PlaceholderEditor,
  options: {
    hasAdd: false,
    hidden: false,
    hasTitle: true,
    isInline: false,
    tags: [],
    adminOnly: false,
  },
};

export default {
  SEO: {
    editor: SeoEditor,
    options: {
      hidden: true,
      hasTitle: true,
      label: 'Definições',
    },
  },
  Breadcrumbs: {
    options: {
      hidden: true,
    },
  },
  SideNav: {
    options: {
      hidden: true,
    },
  },
  Navigation: {
    module: Placeholder,
    editor: SideNavJSON,
    options: {
      hidden: false,
    },
  },
  /* -- Módulo descontinuado
  Agenda: {
    module: Agenda,
    editor: AgendaEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Agenda',
      thumbnail: AgendaThumbnail,
      description:
        '-- Módulo descontinuado. -- Calendário de eventos da UA. Os eventos podem ser filtrados por categoria, permitindo a cada subweb ter a sua agenda de eventos.',
      getDefault: getDefaultAgenda,
      tags: ['agenda', 'dinâmico', 'automático', 'eventos'],
    },
  }, */
  SubWebDepartment: {
    module: (props) => withPortalProviders(SubWebDepartment, props),
    editor: SubwebDepartmentEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Apresentação',
      description: 'Breve descrição de uma unidade orgânica',
      thumbnail: SubWebDepartmentThumbnail,
      getDefault: getDefaultSubWebDepartment,
      tags: ['departamento', 'serviço', 'contacto', 'informação', 'destaque', 'media', 'imagem'],
    },
  },
  Article: {
    editor: ArticleEditor,
    module: (props) => withPortalThemeLegacy(Article, props),
    options: {
      ...moduleDefaults.options,
      label: 'Artigo: texto, imagem e vídeo',
      description:
        'Texto livre com ferramentas de edição e formatação. Possibilidade de inserção de imagem simples e vídeo.',
      thumbnail: ArticleThumbnail,
      getDefault: getDefaultArticle,
      hasTitle: true,
      isInline: true,
      tags: ['video', 'conteúdo', 'imagem', 'media', 'links', 'listas']
    },
  },

  SubWebWarnings: {
    module: (props) => withPortalProviders(SubWebWarnings, props),
    editor: SubWebWarningsEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Avisos',
      description: 'Lista de Avisos',
      thumbnail: SubWebWarningsThumbnail,
      getDefault: getDefaultSubWebWarnings,
      tags: ['avisos', 'notas', 'eventos'],
    },
  },
  Cards: {
    ...moduleDefaults,
    module: Cards,
    editor: CardsEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Cartões',
      description: 'Destaque em cartões',
      thumbnail: CardsThumbnail,
      getDefault: getDefaultCards,
      tags: ['blocos', 'conteúdo', 'informação', 'avisos'],
    }
  },
  SubWebContacts: {
    ...moduleDefaults,
    module: props => withPortalProviders(SubWebContacts, props),
    editor: SubWebContactsEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Contactos',
      description: 'Informação de Contacto. Telefone, redes sociais e mapa',
      thumbnail: SubWebContactsThumbnail,
      getDefault: getDefaultSubWebContacts,
      tags: ['contactos', 'localização', 'mapa', 'email', 'número', 'informação', 'departamento', 'serviço', 'destaque', 'links'],
    }
  },
  SubWebCourses: {
    module: SubWebCoursesInternal,
    editor: SubWebCoursesEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Cursos',
      description: 'Ligações para os tipos de curso oferecidos pela unidade de ensino.',
      thumbnail: SubWebCoursesThumbnail,
      getDefault: getDefaultSubWebCourses,
      tags: ['departamento', 'automático', 'dinâmico', 'ensino', 'cursos', 'unidades curriculares'],
    },
  },
  Slider: {
    module: (props) => withPortalProviders(Header, { ...props, autoplay: false }),
    editor: SliderEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Destaque institucional',
      description:
        'Grande destaque no topo da página principal. Imagem de grande dimensão e link associado (para notícia ou página).',
      thumbnail: SliderThumbnail,
      getDefault: getDefaultSlider,
      tags: ['slide', 'carroussel', 'carousel', 'media', 'video', 'imagem', 'slider'],
    },
  },
  Campus: {
    ...moduleDefaults,
    module: (props) => withPortalProviders(Campos, props),
    editor: CampusEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Destaques',
      description:
        'Destaque de tópicos relevantes no contexto da subweb, composto por título, imagem, breve descrição e um link para aceder a informação mais detalhada.',
      thumbnail: CampusThumbnail,
      getDefault: getDefaultCampus,
      tags: ['blocos', 'imagem', 'media', 'conteúdo'],
    },
  },

  SubWebEvents: {
    module: (props) => withPortalProviders(SubWebEvents, props),
    editor: SubWebEventsEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Eventos',
      description: 'Lista de eventos',
      thumbnail: SubWebEventsThumbnail,
      getDefault: getDefaultSubWebEvents,
      tags: ['eventos', 'calendario', 'programa', 'agenda'],
    },
  },
  /* SubWebFiles: {
    module: (props) => withPortalProviders(Files, props),
    editor: SubWebFilesEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Ficheiros',
      description: 'Lista de ficheiros',
      thumbnail: SubWebFilesThumbnail,
      getDefault: getDefaultSubWebFiles,
      tags: ['ficheiros', 'artigos', 'lista', 'tabela'],
    },
  }, */
  Facts: {
    module: (props) => withPortalProviders(Facts, props),
    editor: FactsEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Frase ou citação',
      description:
        'Frase ou citação em destaque com indicação da fonte e/ou data associada.',
      thumbnail: FactsThumbnail,
      getDefault: getDefaultFacts,
      tags: ['conteúdo', 'serifado', 'citação'],
    },
  },
  Gallery: {
    module: (props) => withPortalProviders(Gallery, { ...props, hasTheater: false }),
    editor: GalleryEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Galeria',
      description: 'Galeria de imagens em colunas e com modo teatro.',
      thumbnail: GalleryThumbnail,
      getDefault: getDefaultGallery,
      tags: ['imagens', 'lista', 'imagem', 'album', 'fotos'],
    },
  },


  SubWebSchedule: {
    module: (props) => withPortalProviders(SubWebSchedule, props),
    editor: SubWebScheduleEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Horário',
      description: 'Informações de horário',
      thumbnail: SubWebScheduleThumbnail,
      getDefault: getDefaultSubWebSchedule,
      tags: ['horário', 'calendario', 'contactos', 'atendimento'],
    },
  },

  Image: {
    editor: ImageEditor,
    module: (props) => generateImage(props),
    options: {
      ...moduleDefaults.options,
      label: 'Imagem panorâmica',
      description: 'Imagem panorâmica que ocupa toda a largura da página.',
      getDefault: getDefaultImage,
      thumbnail: ImageThumbnail,
      tags: ['imagem', 'media', 'seperador'],
    },
  },
  SubWebLinks: {
    module: (props) => withPortalProviders(SubWebCourses, props),
    editor: SubWebLinksEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Links',
      description: 'Ligações para áreas importantes de uma subweb',
      thumbnail: SubWebLinksThumbnail,
      getDefault: getDefaultSubWebLinks,
      tags: ['cursos', 'destaques', 'serviços'],
    },
  },
  News: {
    module: News,
    editor: NewsEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Notícias',
      thumbnail: NewsThumbnail,
      description:
        'Notícias da UA mais recentes. Possibilidade de configuração para filtrar as notícias de uma categoria ou filtro.',
      getDefault: getDefaultNews,
      tags: ['dinâmico', 'automático', 'eventos', 'destaques', 'artigos', 'jornal'],
    },
  },
  Contests: {
    module: Contests,
    editor: ContestsEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Concursos',
      thumbnail: ContestsThumbnail,
      description:
        'Lista de concursos',
      getDefault: getDefaultContests,
      tags: ['concursos', 'candidaturas'],
    },
  },
  Timely: {
    module: Timely,
    editor: TimelyEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Timely',
      thumbnail: TimelyThumbnail,
      description:
        'Calendário de eventos da UA suportado pela plataforma Timely.',
      getDefault: getDefaultTimely,
      tags: ['Agenda', 'Eventos'],
    },
  },
  OneFact: {
    ...moduleDefaults,
    module: (props) => withPortalProviders(OneFact, props),
    editor: OneFactEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Número e texto',
      description:
        'Número de grande dimensão acompanhado de um breve texto descritivo.',
      thumbnail: OneFactThumbnail,
      getDefault: getDefaultOneFact,
      tags: ['frase', 'conteúdo', 'destaque', 'facto'],
    },
  },
  Numbers: {
    editor: NumbersEditor,
    module: (props) => withPortalProviders(Numbers, props),
    options: {
      ...moduleDefaults.options,
      label: 'Números',
      description:
        'Destaque de quatro números relevantes no contexto da subweb, com a respetiva legenda.',
      thumbnail: NumbersThumbnail,
      getDefault: getDefaultNumbers,
      tags: ['conteúdo', 'destaque', 'facto', 'factos', 'estatísticas'],
    },
  },
  SubWebPeople: {
    // module: SubWebPeople,
    module: (props) => withPortalProviders(SubWebPeople, props),
    editor: SubWebPeopleEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Pessoas',
      description: 'Lista de pessoas associadas a uma unidade orgânica ou serviço, com opção de edição à medida.',
      thumbnail: SubWebPeopleThumbnail,
      getDefault: getDefaultSubWebPeople,
      tags: ['recursos humanos', 'automático', 'dinâmico', 'professores', 'docentes', 'funcionários'],
    },
  },


  Tables: {
    ...moduleDefaults,
    module: (props) => withPortalProviders(Tables, props),
    editor: TablesEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Tabelas',
      description:
        'Editor de tabelas.',
      thumbnail: TablesThumbnail,
      getDefault: getDefaultTables,
      isInline: true,
      tags: ['conteúdo', 'colunas'],
    },
  },
  Testimonials: {
    module: (props) => withPortalProviders(About, props),
    editor: TestimonialsEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Testemunhos',
      description:
        'Texto curto e fotografia de perfil. Partilha, na primeira pessoa, de vivências ou acontecimentos com algum tipo de ligação à UA.',
      thumbnail: TestimonialsThumbnail,
      getDefault: getDefaultTestimonials,
      tags: ['conteúdo', 'colunas', 'pessoas', 'review', 'frase', 'citação', 'caras'],
    },
  },
  TestimonialsWithLink: {
    module: (props) => withPortalProviders(TestimonialsWithLink, props),
    editor: TestimonialsWithLinkEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Testemunhos com link',
      description:
        'Texto curto e fotografia de perfil com link. Partilha, na primeira pessoa, de vivências ou acontecimentos com algum tipo de ligação à UA.',
      thumbnail: TestimonialsWithLinkThumbnail,
      getDefault: getDefaultTestimonialsWithLink,
      tags: ['conteúdo', 'colunas', 'pessoas', 'review', 'frase', 'citação', 'caras'],
    },
  },
  MultiColumns: {
    editor: MultiColumnsEditor,
    module: MultiColumns,
    options: {
      ...moduleDefaults.options,
      label: 'Texto em colunas',
      description: 'Texto curto, apresentado com possibilidade de duas colunas.',
      getDefault: getDefaultMultiColumns,
      thumbnail: MultiColumnsThumbnail,
      tags: ['frase', 'destaque', 'conteúdo'],
    },
  },
  SubWebVideo: {
    module: (props) => withPortalProviders(Streaming, props),
    editor: SubWebVideoEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Video',
      description: 'Destaque de um video com descrição.',
      thumbnail: SubWebVideoThumbnail,
      getDefault: getDefaultSubWebVideo,
      tags: ['video', 'tese', 'streaming', 'youtube', 'dissertação'],
    },
  },
  Xperimenta: {
    module: Xperimenta,
    editor: XperimentaEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Xperimenta',
      description: 'Módulo para o evento Xperimenta com informação sobre os cursos e sessões associadas.',
      thumbnail: XperimentaThumbnail,
      getDefault: getDefaultXperimenta,
      tags: ['xperimenta', 'cursos'],
      adminOnly: true,
    },
  },
  FAQ: {
    module: (props) => withPortalProviders(FAQ, props),
    editor: FaqEditor,
    options: {
      ...moduleDefaults.options,
      label: 'Perguntas frequentes',
      description: 'Secções de texto que expandem e recolhem, ao estilo acordeão, com a possibilidade de criar categorias.',
      thumbnail: FAQThumbnail,
      getDefault: getDefaultFAQ,
    },
  },
  Placeholder: {
    ...moduleDefaults,
  },
};
